import { Checkbox, FormControlLabel, Stack, styled } from '@mui/material'
import { memo, useCallback } from 'react'
import { useAppDispatch } from 'store'
import { TradeType } from 'store/market/types'
import { updatePerpPostOnlyAction } from 'store/perp/actions'
import { usePerpPostOnly } from 'store/perp/hooks'
import { useCurrentPlaceOrderTIF } from 'store/settings/hooks'
import { updateSpotPostOnlyAction } from 'store/spot/actions'
import { useSpotPostOnly } from 'store/spot/hooks'
import { TooltipText } from '../TooltipText'

const StyledPlaceOrderPostOnly = styled(Stack)``

const StyledFormControlLabel = styled(FormControlLabel)`
  margin-left: 0;
  .MuiFormControlLabel-label {
    font-size: 14px;
    line-height: 1.4;
    color: ${(props) => props.theme.color.text50};
  }
  .Mui-checked {
    .MuiSvgIcon-root {
      color: rgba(160, 238, 9, 1) !important;
    }
  }
`
const StyledCheckbox = styled(Checkbox)`
  padding: 0;
  margin-right: 2px;
  .MuiSvgIcon-root {
    width: 17px;
    height: 17px;
    color: #7b8891;
  }
`

export const PlaceOrderPostOnly = memo<{ tradeType: TradeType }>(
  ({ tradeType }) => {
    const dispatch = useAppDispatch()
    const perpPostOnly = usePerpPostOnly()
    const spotPostOnly = useSpotPostOnly()

    const currentPostOnly =
      tradeType === TradeType.Perp ? perpPostOnly : spotPostOnly

    const handleChange = useCallback(
      (postOnly: boolean) => {
        if (tradeType === TradeType.Perp) {
          dispatch(updatePerpPostOnlyAction(postOnly))
        } else {
          dispatch(updateSpotPostOnlyAction(postOnly))
        }
      },
      [tradeType],
    )
    const currentTif = useCurrentPlaceOrderTIF()[tradeType]

    if (currentTif !== 'Good-Till-Time') return <div />

    return (
      <StyledPlaceOrderPostOnly>
        <StyledFormControlLabel
          control={<StyledCheckbox />}
          label={
            <TooltipText
              title={`The Post-Only order will only be executed as a maker order.
            If it can be executed immediately as a taker order,
            it will be automatically canceled`}
              placement="left-start"
            >
              Post-Only
            </TooltipText>
          }
          defaultChecked={currentPostOnly}
          checked={currentPostOnly}
          onChange={(e: any) => handleChange(e.target.checked)}
        />
      </StyledPlaceOrderPostOnly>
    )
  },
)
